import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import $api from "../api/$api";
import { TDataToken, TDisconnectLoginParams } from "./types";

export const disconnectLogin = (
  data: TDataToken,
  params: TDisconnectLoginParams
) => {
  const { userId, teamId, authType } = params;

  return $api.delete(`/users/${userId}/teams/${teamId}/auth`, {
    // @ts-ignore
    token: data.accessToken,
    data: { authType }
  });
};

export const useDisconnectLogin = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, TDisconnectLoginParams>
) => {
  return useMutation({
    mutationFn: (payload: TDisconnectLoginParams) =>
      disconnectLogin(data, payload),
    ...config
  });
};
